// extracted by mini-css-extract-plugin
module.exports = {"card":"Widget_card__umzyw","filters":"Widget_filters__2ZFzk","header":"Widget_header__3OPIk"};